export type TagSet = {
  tagID: number;
  tag: string;
  name: string;
  type: string;
  url: string;
  localizationKey?: string;
  accessKey?: string;
  mergeWith?: string[];
};

export const tagSet: { [key: string]: TagSet } = {
  step1: {
    tagID: 1,
    tag: 'Step 1',
    name: 'USMLE® Step 1',
    type: 'step1',
    url: 'step1/questions',
    localizationKey: 'step_1_questions',
    accessKey: 'has_step_1_questions',
  },
  step2: {
    tagID: 2,
    tag: 'Step 2',
    name: 'USMLE® Step 2',
    type: 'step2',
    url: 'step2/questions',
    localizationKey: 'step_2_questions',
    accessKey: 'has_step_2_questions',
  },
  comlex: {
    tagID: 3,
    tag: 'COMLEX',
    name: 'COMLEX',
    type: 'comlex',
    url: 'comlex/questions',
    mergeWith: ['step1', 'step2', 'comlexl1', 'comlexl2'],
  },
  'nclex-rn': {
    tagID: 15,
    tag: 'NCLEX-RN',
    name: 'NCLEX',
    type: 'nclex-rn',
    url: 'nclex/questions',
    accessKey: 'has_nclex_questions',
  },
  pance: {
    tagID: 16,
    tag: 'PANCE',
    name: 'PANCE',
    type: 'pance',
    url: 'pance/questions',
    accessKey: 'has_pance_questions',
  },
  ngn: {
    tagID: 23,
    tag: 'NGN',
    name: 'NGN',
    type: 'ngn',
    url: 'ngn/questions',
    accessKey: 'has_ngn_questions',
  },
  comlexl1: {
    tagID: 17,
    tag: 'COMLEX Level 1',
    name: 'COMLEX-USA® Level 1',
    type: 'comlexl1',
    url: 'comlexl1/questions',
    accessKey: 'has_comlex_1_questions',
    mergeWith: ['step1', 'comlex'],
  },
  comlexl2: {
    tagID: 18,
    tag: 'COMLEX Level 2',
    name: 'COMLEX-USA® Level 2',
    type: 'comlexl2',
    url: 'comlexl2/questions',
    accessKey: 'has_comlex_2_questions',
    mergeWith: ['step2', 'comlex'],
  },
  flashcard: {
    tagID: 4,
    tag: 'Flashcards',
    name: 'Flashcards',
    type: 'flashcard',
    url: 'step1/flashcards',
    accessKey: 'has_fc_md',
  },
  cna: {
    tagID: 24,
    tag: 'CNA',
    name: 'Nursing Assistant',
    type: 'cna',
    url: 'cna/questions',
    accessKey: 'has_cna_questions',
  },
  foundationalQuestions: {
    tagID: 25,
    tag: 'Recall',
    name: 'Recall',
    type: 'foundationalQuestions',
    url: 'foundational/questions',
    localizationKey: 'foundational_questions',
    accessKey: 'has_foundational_questions',
  },
  cme: {
    tagID: 13,
    tag: 'CME',
    name: 'CME',
    type: 'cme',
    url: 'cme/questions',
  },
};

/**
 * .
 */
export const getNameFromTagSet = (key: string): string => {
  return tagSet[key]
    ? tagSet[key].name
    : `${key.charAt(0).toUpperCase()}${key.slice(1)}`;
};
